$(document).ready(async function() { 
    localStorageProcessing = true;
    localStorage.setItem("localStorageWork", true);
    let form = $('product-form form');
    var formData = form.serializeArray();
    formData = formData.filter(item => (item.name.includes('properties') || item.name.includes('prop') || item.name.includes('frame-selector')))
    formData = formData.filter(item => !form_filters.some(filter => item.name.includes(filter)))          

    let handle_at_end_items = ['bp-illustration-value', 'bp-language-selector', 'ptp-filter-range', 'bp-stars-over-text'];

    let coordinates = '';
    // function storeFormData() {
    //     formData.forEach(item => {
    //         localStorage.setItem(item.name, item.value);
    //     });
    // }

    function cleanUrl() {
        var url = new URL(window.location.href);
        url.searchParams.delete('values');
        window.history.replaceState({}, document.title, url.toString());
    }

    function AttachStorageListeners() {
        formData.forEach(item => {
            $(`[name="${item.name}"]`).on('change input', function(){
                localStorage.setItem($(this).attr('name'), $(this).val());
            });
        });
    }

    function reviewChangesListeners() {
        formData.forEach(item => {
            $(`[name="${item.name}"]`).on('change input', function(){
                if((typeof changes_made !== 'undefined')) {
                    changes_made = true;
                    $('.product-form__submit[name="add"]').removeAttr('aria-disabled');
                    if($('.product-form__submit[name="add"]').attr("disabled") != 'disabled') {
                        $('.product-form__submit[name="add"] > span').text(window.variantStrings.saveChanges)
                    }
                  }
            });
        });
    }

    function fillFormFromLocalStorage() {
        // i need to handle illustration change at end as it changes the length if done before
        let handle_at_end = [];
        formData.forEach(item => {
            const storedValue = localStorage.getItem(item.name);
            const element = $(`[name="${item.name}"]`)
            if (handle_at_end_items.some((item) => element.hasClass(item))) {
                handle_at_end.push(item);
            }
            else {
                if(storedValue !== null && element) {
                    if (element.hasClass('bp-star-coordinates')){
                        element.val(storedValue);
                        element.change();
                        coordinates = storedValue;
                    }
                    else if(element.is(':radio')) {
                        element.filter(`[value="${storedValue}"]`).click();
                        if (element.hasClass('bp-background-radio')){
                            let left_scroll = ($(`.bp-swatch-container:has(.bp-background-radio:checked)`).position().left + $(`.bp-bg-block:has(.bp-background-radio:checked)`).scrollLeft() - $(`.bp-bg-block:has(.bp-background-radio:checked)`).width() + (2 * $(`.bp-swatch-container:has(.bp-background-radio:checked)`).width()))
                            $(`.bp-bg-block:has(.bp-background-radio:checked)`).animate({
                                scrollLeft: left_scroll
                            }, {
                                duration: 200,  // Animation duration in milliseconds
                                easing: 'linear' // Linear easing for smooth, constant speed
                            });
                        }
                        else if (element.hasClass('bp-illustration-radio')){
                            let left_scroll = ($(`.bp-swatch-container:has(.bp-illustration-radio[data-index="${element[0].dataset.index}"]:checked)`).position().left + $(`.bp-illustration-block:has(.bp-illustration-radio[data-index="${element[0].dataset.index}"]:checked)`).scrollLeft() - $(`.bp-illustration-block:has(.bp-illustration-radio[data-index="${element[0].dataset.index}"]:checked)`).width() + (2 * $(`.bp-swatch-container:has(.bp-illustration-radio[data-index="${element[0].dataset.index}"]:checked)`).width()))
                            $(`.bp-illustration-block:has(.bp-illustration-radio[data-index="${element[0].dataset.index}"]:checked)`).animate({
                                scrollLeft: left_scroll
                            }, {
                                duration: 200,  // Animation duration in milliseconds
                                easing: 'linear' // Linear easing for smooth, constant speed
                            });
                        }
                    }
                    else {
                        element.val(storedValue)
                        element.change();
                    }
                }
            }
        });
        handle_at_end.forEach( item => {
            const storedValue = localStorage.getItem(item.name);
            const element = $(`[name="${item.name}"]`)
            if(storedValue !== null && element) {
                if(element.is(':radio')) {
                    element.filter(`[value="${storedValue}"]`).click();
                }
                else {
                    element.val(storedValue)
                    element.change();
                }
            }
        })
    }

    function fillFormFromURLParams(values = '') {
        let encoded_values = '';
        if(values) {
            encoded_values = values;
        }
        else {
            const params = new URLSearchParams(window.location.search);
            encoded_values = params.get('values')
        }
        let handle_at_end = [];
        if(encoded_values){
            let sp_encoded_string = decodeURIComponent(encoded_values);
            let jsonString = window.mySpecialDecoding(sp_encoded_string)
            const obj = JSON.parse(jsonString);
            formData.forEach(item => {
                let found_obj = obj.filter((itm) => itm.name == item.name)
                var storedValue = '';
                if(found_obj.length) {
                    storedValue = found_obj[0].value;
                    if((typeof edit_cart !== 'undefined' && edit_cart == true && item.name == "frame-selector") 
                    || (typeof edit_item !== 'undefined' && edit_item == true && item.name == "frame-selector")) {
                        storedValue = "no_frame"
                    }
                    localStorage.setItem(item.name, storedValue);
                }
                else {
                    localStorage.removeItem(item.name);
                    return;
                }
                const element = $(`[name="${item.name}"]`);
                if (handle_at_end_items.some((item) => element.hasClass(item))) {
                    handle_at_end.push(item);
                }
                else {
                    if(storedValue !== null && element) {
                        if (element.hasClass('bp-star-coordinates')){
                            element.val(storedValue);
                            element.change();
                            coordinates = storedValue;
                        }
                        else if(element.is(':radio')) {
                            element.filter(`[value="${storedValue}"]`).click();
                            if (element.hasClass('bp-background-radio')){
                                let left_scroll = ($(`.bp-swatch-container:has(.bp-background-radio:checked)`).position().left + $(`.bp-bg-block:has(.bp-background-radio:checked)`).scrollLeft() - $(`.bp-bg-block:has(.bp-background-radio:checked)`).width() + (2 * $(`.bp-swatch-container:has(.bp-background-radio:checked)`).width()))
                                $(`.bp-bg-block:has(.bp-background-radio:checked)`).animate({
                                    scrollLeft: left_scroll
                                }, {
                                    duration: 200,  // Animation duration in milliseconds
                                    easing: 'linear' // Linear easing for smooth, constant speed
                                });
                            }
                            else if (element.hasClass('bp-illustration-radio')){
                                let left_scroll = ($(`.bp-swatch-container:has(.bp-illustration-radio[data-index="${element[0].dataset.index}"]:checked)`).position().left + $(`.bp-illustration-block:has(.bp-illustration-radio[data-index="${element[0].dataset.index}"]:checked)`).scrollLeft() - $(`.bp-illustration-block:has(.bp-illustration-radio[data-index="${element[0].dataset.index}"]:checked)`).width() + (2 * $(`.bp-swatch-container:has(.bp-illustration-radio[data-index="${element[0].dataset.index}"]:checked)`).width()))
                                $(`.bp-illustration-block:has(.bp-illustration-radio[data-index="${element[0].dataset.index}"]:checked)`).animate({
                                    scrollLeft: left_scroll
                                }, {
                                    duration: 200,  // Animation duration in milliseconds
                                    easing: 'linear' // Linear easing for smooth, constant speed
                                });
                            }
                        }
                        else {
                            element.val(storedValue)
                            element.change();
                        }
                    }
                }
            });
            handle_at_end.forEach( item => {
                let found_obj = obj.filter((itm) => itm.name == item.name)
                var storedValue = '';
                if(found_obj.length) {
                    storedValue = found_obj[0].value;
                }
                else {
                    localStorage.removeItem(item.name);
                    return;
                }
                const element = $(`[name="${item.name}"]`)
                if(storedValue !== null && element) {
                    if(element.is(':radio')) {
                        element.filter(`[value="${storedValue}"]`).click();
                    }
                    else {
                        element.val(storedValue)
                        element.change();
                    }
                }
            })
            if(typeof preview_template === 'undefined' || preview_template == false)
            cleanUrl();
        }
    }

    function makeURL() {
        formData = form.serializeArray();
        formData = formData.filter(item => (item.value != '' || by_default_valued_properties.some(prop => item.name.includes(prop))));
        formData = formData.filter(item => (item.name.includes('properties') || item.name.includes('prop') || item.name.includes('frame-selector')))
        formData = formData.filter(item => !form_filters.some(filter => item.name.includes(filter)))
        
        const jsonString = JSON.stringify(formData);
        let sp_encoded_string = window.myVerifiedEncoding(jsonString);
        const encoded_string = encodeURIComponent(sp_encoded_string);

        var url_visit = new URL(window.location.href);
        url_visit.searchParams.delete("item_key");
        url_visit.searchParams.append("values", encoded_string)
        return url_visit.href
    }

    function makePreviewURL() {
        var url_visit = new URL(makeURL());
        url_visit.searchParams.append("view", 'birthposter_preview')
        return url_visit.href
    }
    
    async function fillDataFromBackend(item_key) {
        let auth_key = '0LlHH9jBVy8qk4oqPSKCucIbEfnmmaiWUM3UzoccecUE5zCZmX7FDYFa7R8UKWmX';
        let headers = {
            'Content-Type': 'application/json',
            'X-API-Key': auth_key
        }
        
        let api_url = `https://dashboard.birthbox.se/api/v1/shopify`;
        let order_item_endpoint = api_url + `/order-item/${item_key}`;
        let order_lock_endpoint = api_url + `/order-item-lock/${item_key}`; 

        // let response = await delay(2000);

        let response = await fetch(order_item_endpoint, {
            method: 'GET',
            headers: headers
        });
        response = await response.json();

        if(response.update_status == "available" && response.hasOwnProperty("data")) {
            let update_type = response.data.update_type || '';
            if(update_type == "customer") {
                setInterval(() => {
                    fetch(order_lock_endpoint, {
                        method: 'POST',
                        headers: headers
                    });
                }, 90000);
            }

            let data_url = response.data.data_url || '';
            if(data_url) {
                data_url = new URL(data_url);
                const params = new URLSearchParams(data_url.search);
                let values = params.get('values');
                if(values) {
                    fillFormFromURLParams(values)
                }
            }
            let illustration_1 = response.data.illustration_1 || '';
            if(illustration_1) {
                $(`.bp-variant-options-radio[data-index="1"][data-value="${illustration_1}"]`).click();
            }
            let starmap = response.data.svg || '';
            if(typeof curr_svg_url !== 'undefined' && starmap) {
                curr_svg_url = starmap;
            }
            $(".custom_loading_overlay .loading__spinner").addClass("hidden");
        }
        else if(response.update_status == "locked") {
            let message = "The order is currently locked for editing."
            $('.custom_message_with_logo').append(`<div class="custom__message">${message}</div>`);
            $(".custom_loading_overlay .loading__spinner").addClass("hidden");
        }
        else {
            let message = "You can no longer make changes to your poster. For more information, contact info@thebirthposter.com."
            if(edit_link_error_message) {
                message = edit_link_error_message;
            }
            $('.custom_message_with_logo').append(`<div class="custom__message">${message}</div>`);
            $(".custom_loading_overlay .loading__spinner").addClass("hidden");
        }
    }

    AttachStorageListeners();
    if(typeof edit_item !== 'undefined' && edit_item == true) {
        reviewChangesListeners();
        await fillDataFromBackend(item_key);
    }
    else {
        fillFormFromURLParams();
    }
    fillFormFromLocalStorage();

    localStorageProcessing = false;
    localStorage.removeItem("localStorageWork");

    //this is done because i need range disabled on original which is the default value. 
    //But if we add disabled as html attr then local storage event listener is not attached so we add after listener is attached
    if($('.ptp-filter-radio:checked').val() == "filter-original") {
        $('.ptp-filter-range').val(100)
        $('.ptp-filter-range').attr("disabled", true)
    }

    function getPoint(lat, long, date) {
        lat = Number(lat),
        long = Number(long);
        let point = Celestial.getPoint(Celestial.horizontal.inverse(date, [90, 0], [lat, long]), "equatorial");
        
        point[2] = 0;
        return point
    }

    function convertToDate(dateString) {
        const datePart = dateString.split(' ')[0] || '01-01-2024';
        let timePart = dateString.split(' ')[1] || '00:00';
        let timeunit = ""
        if(timePart.includes('AM')){
            timeunit = "am";
        }
        if(timePart.includes('PM')){
            timeunit = "pm";
        }
        timePart = timePart.replace("AM", "").replace("PM", "");
        const [day, month, year] = datePart.split('-');
        let [hours, minutes] = timePart.split(':');

        if (timeunit === "pm" && hours !== "12" && hours !== "") {
            hours = parseInt(hours);
            hours += 12;
        } else if (timeunit === "am" && hours === "12" && hours !== "") {
            hours = parseInt(hours);
            hours = 0; // Midnight case
        }

        let date = new Date(Date.UTC(year, month - 1, day, hours, minutes, 0, 0));
        return date
    }


    if(coordinates && (typeof Celestial !== "undefined")) {
        const cord = coordinates.split(',');
        if(cord.length == 2) {
            latitude = cord[0];
            longitude = cord[1];
            let date = $('.birth-date').val();
            let time = $('.birth-time').val();
            let date_object = convertToDate(`${date} ${time}`);
    
            clearTimeout(starPosterCallbackTimeout);

            starPosterCallbackTimeout = setTimeout(() => {
                Celestial.rotate({
                    center: getPoint(latitude, longitude, date_object),
                    horizon: 0
                });
            }, 1000);
        }
    }

    window.addEventListener("klaviyoForms", function(e) {
        if (e.detail.type == 'submit') {
            var url_visit = makeURL();
            var klaviyo = window.klaviyo || [];
            console.log(e.detail.metaData.$email, url_visit, klaviyo);
            klaviyo.identify({ '$email': e.detail.metaData.$email}, function() {
                klaviyo.identify({ 'URL': url_visit}, function() {   
                    klaviyo.track('Save design for later') 
                })
            })
        }
    });

    $('button.bp-save-for-later-btn').click(function(){
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', save_for_later_id]);        
    });

    if(typeof preview_template === 'undefined' || preview_template == false) {
         if(localStorage.getItem('prop[Language]') === null && typeof default_language !== 'undefined'){
             $('.bp-language-selector').each(function() {
                 let val = $(this).find(`option[data-iso="${default_language}"]`).val()
                 if(val) {
                     $(this).val(val);
                     $(this).change();
                 }
             })
             localStorage.removeItem(`prop[Language]`)
         }
    }
    console.log(makeURL());

    // due to local storage work it shows as true. I need to make it false so only when it is changed by user input I can check
    if(typeof svg_changed !== 'undefined') {
        svg_changed = false;
    }
});